import { Component, Renderer2, OnInit } from '@angular/core';
import { UtilService } from '../../../services/util.service';
import { catchError, of, firstValueFrom } from 'rxjs';
import { FooterInfoResponseDTO } from '../../../dto/util/footerInfoDTO';
import footerData from '../../../../assets/json/footer.json';
import { Constants } from '../../../constants/constants';
import { EntidadService } from '../../../services/entidad.service';
import { EntidadDto } from '../../../dto/entidad/entidad.dto';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent implements OnInit {
  footerInfo!: FooterInfoResponseDTO;

  entidadJustifacil: EntidadDto = {
    id: 0,
    entidad: '',
  };

  constructor(
    private renderer: Renderer2,
    private utilService: UtilService,
    private entidadService: EntidadService,
  ) {
    this.entidadService.obtenerEntidadJustifacil().subscribe(response => {
      this.entidadJustifacil = response;
    });
  }

  async ngOnInit(): Promise<void> {
    const storedFooterInfo = sessionStorage.getItem(
      Constants.FOOTER_INFORMATION_STORAGE
    );

    if (storedFooterInfo) {
      this.footerInfo = JSON.parse(storedFooterInfo);
    } else {
      const footerInfo = await firstValueFrom(
        this.utilService.getFooterInfo().pipe(
          catchError(() => {
            return of(footerData); // footerData es un fallback
          })
        )
      );
      this.footerInfo = footerInfo;
      sessionStorage.setItem(
        Constants.FOOTER_INFORMATION_STORAGE,
        JSON.stringify(footerInfo)
      );
    }

    const backGoToUpElement = this.renderer.selectRootElement(
      '.volver-arriba-govco'
    );

    // Agregar listener al botón
    this.renderer.listen(backGoToUpElement, 'click', () => {
      this.backGoToUp();
    });
  }

  backGoToUp(): void {
    // Desplazar la página hacia arriba
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // Esto agrega un efecto de desplazamiento suave
    });
  }
}
